
export const UnloggedAlert = ()=>{
    return(
        <>
            <div
                className="alert alert-danger"
                role="alert"
            >
                <h4 className="alert-heading">Usuario sin Permisos</h4>
                <hr />
                <p className="mb-0">Debe iniciar sesión para poder acceder a esta sección</p>
            </div>
            
        </>
    );
}

export const UsuarioSinPrivilegios  = ()=>{
    return(
    <div
        className="alert alert-danger"
        role="alert"
    >
        <h4 className="alert-heading">ACCESO NO PERMITIDO</h4>
        <p>El usuario no posee los privilegios necesarios para acceder a esta sección</p>
        <hr />
        <p className="mb-0">Para aumentar privilegios contacte al administrador</p>
    </div>
    );
}
